import React, { FC } from 'react';
import { AddUserError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { AddUserErrorProps } from './types';
import { FooterButtonStyled } from '../styled';

const getErrorMessage = (error: AddUserErrorProps['addUserError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AddUserError.USER_NOT_SAVED:
      return <Trans>User not saved.</Trans>;
    case AddUserError.USER_ALREADY_EXISTS:
      return <Trans>User already exists.</Trans>;
    case AddUserError.INVALID_ROLE_ID:
      return <Trans>Invalid Roles.</Trans>;
    case AddUserError.INVALID_DISCIPLINE_ID:
      return <Trans>Invalid Disciplines.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const UserAddError: FC<AddUserErrorProps> = ({ addUserError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="add-user-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Update User Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(addUserError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
